import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
export const Hero = () => {
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 lg:pt-32 lg:pb-24 overflow-hidden" data-id="element-35">
      {/* Subtle background decoration */}
      <div className="absolute top-0 left-0 w-full h-full bg-wellness-cream-dark/30 -z-10" data-id="element-36" />
      <div className="absolute -top-40 -right-40 w-[600px] h-[600px] bg-wellness-sage/10 rounded-full blur-3xl -z-10" data-id="element-37" />

      <div className="container mx-auto px-6 max-w-7xl" data-id="element-38">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-39">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="max-w-2xl" data-id="element-40">
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.3,
            duration: 0.8
          }} className="inline-block mb-4 px-3 py-1 border border-wellness-sage text-wellness-forest text-sm uppercase tracking-widest font-medium rounded-full" data-id="element-41">
              The Reset Protocol
            </motion.div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl leading-[1.1] mb-6 text-balance" data-id="element-42">
              The Menopause <br data-id="element-43" />
              <span className="italic text-wellness-gold" data-id="element-44">
                Belly Reset
              </span>{' '}
              Protocol
            </h1>

            <p className="text-xl md:text-2xl font-serif text-wellness-forest/80 mb-8 leading-relaxed text-balance" data-id="element-45">
              The "Hormone-First" shortcut to shedding stubborn midsection
              weight and ending the 11 PM bloat—without brutal cardio or
              starving yourself.
            </p>

            <div className="prose prose-lg text-wellness-forest/70 mb-10 font-sans font-light leading-relaxed" data-id="element-46">
              <p data-id="element-47">
                It happened almost overnight. You woke up, pulled on your
                favorite jeans, and they wouldn't zip. Or worse—they zipped, but
                the "spare tire" spilling over the waistband was something you
                never authorized to live there.
              </p>
              <p data-id="element-48">
                You haven't changed your diet. You haven't stopped moving. But
                your body has stopped listening. You feel puffy, tired, and
                honestly, a little betrayed by the mirror.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-49">
              <Button variant="primary" size="lg" onClick={() => document.getElementById('offer')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-50">
                Start Your Reset Today
              </Button>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative lg:h-[700px] flex items-center justify-center" data-id="element-51">
            {/* Decorative frame for image */}
            <div className="absolute inset-0 bg-wellness-sage/20 rounded-t-full rounded-b-[4rem] transform -rotate-3 scale-105 -z-10" data-id="element-52" />
            <img src="https://cdn.magicpatterns.com/uploads/gbg4mnsiUmBxJbnhJMtuF1/heylloyd-image-1778333244328.png" alt="The Menopause Belly Reset Protocol Digital Product" className="w-full h-auto object-cover rounded-2xl shadow-2xl" data-id="element-53" />
          </motion.div>
        </div>
      </div>
    </section>;
};